import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared.module';
import { RouterModule } from '@angular/router';
import { AllStylistViewCalendarComponent } from './all-stylist-view-calendar.component';
import { DayViewCalendarComponentModule } from '../day-view-calendar/day-view-calendar.module';

import { CircleTextAvatarComponentModule } from '../../../components/shared/circle-text-avatar/circle-text-avatar.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    RouterModule,
    DayViewCalendarComponentModule,
    CircleTextAvatarComponentModule
  ],
  declarations: [AllStylistViewCalendarComponent],
  exports: [AllStylistViewCalendarComponent]
})
export class AllStylistViewCalendarComponentModule {}
